// Keyboard Keycode

export const Enter = {
  key: 'Enter',
  code: 'Enter',
};

export const Esc = {
  key: 'Escape',
  code: 'Escape',
};

export const Backspace = {
  key: 'Backspace',
  code: 'Backspace',
};

export const Tab = {
  key: 'Tab',
  code: 'Tab',
};

export const Space = {
  key: '',
  code: 'Space',
};
export const ArrowUp = {
  key: 'ArrowUp',
  code: 'ArrowUp',
};

export const ArrowDown = {
  key: 'ArrowDown',
  code: 'ArrowDown',
};

export const ArrowLeft = {
  key: 'ArrowLeft',
  code: 'ArrowLeft',
};

export const ArrowRight = {
  key: 'ArrowRight',
  code: 'ArrowRight',
};
